import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageUploaderComponent } from './image-uploader.component';



@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [ImageUploaderComponent],
    declarations: [ImageUploaderComponent],
    providers: [],
})
export class ImageUploaderModule { }
